import React from 'react';

import Badge, { Props } from 'four-nets/ui-v2/badges/badge/badge';

import defaultStyles from './homepage-badge.scss';

export const StyledBadge = (props: Omit<Props, 'styles'>) => (
    <Badge style={{ badge: defaultStyles.badge }} {...props} />
);
